import { VALIDATE_FIELD } from "./constant";
import { takeLatest, put, call } from "redux-saga/effects";

function* validateFields(action) {
    /* console.log('saga.action', action); */
}

export function* watchUsers() {
    yield takeLatest(VALIDATE_FIELD, validateFields);
}